import { observer } from 'mobx-react';

import { Header } from '@assets/component/Header/Header';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { useStore, useStoreUI } from '@assets/model/Store';
import {
    getAuth,
    sendPasswordResetEmail,
    signInWithEmailAndPassword
} from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

const LoginPage = observer(() => {
    const { id } = useParams();
    const store = useStore();
    const navigate = useNavigate();

    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [resetEmail, setResetEmail] = useState('');
    const [authState, setAuthState] = useState(false);

    useEffect(() => {
        const uiStore = useStoreUI();
        uiStore.disableLoading = true;

        // Set up navigation callback for Firebase adapter
        getFirebase().setNavigationCallback((path: string) => {
            // Re-enable loading when navigating away from login
            if (path === '/') {
                uiStore.disableLoading = false;
            }
            navigate(path);
        });
    }, [navigate]);

    useEffect(() => {
        const auth = getAuth(getFirebase().app);
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user) {
                setAuthState(true);
                // Add delay to show green status before redirecting
                setTimeout(() => {
                    const uiStore = useStoreUI();
                    const store = useStore();

                    // Set loading state BEFORE navigation to prevent flicker
                    uiStore.disableLoading = false;
                    uiStore.forceLoading = true;

                    navigate('/');

                    // Clear force loading after showing loading screen
                    setTimeout(() => {
                        uiStore.forceLoading = false;
                    }, 2000); // Show loading for 2 seconds
                }, 750);
            } else {
                setAuthState(false);
            }
        });

        return () => unsubscribe();
    }, [navigate]);
    const login = async () => {
        const auth = getAuth(getFirebase().app);
        try {
            const user = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword
            );

            if (user) {
                getFirebase().store_audit_entry('LOGIN');
                // Navigation will be handled by the auth state change listener
            }
        } catch (e) {
            alert('Invalid user/pass');
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        login();
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            login();
        }
    };

    const sendReset = () => {
        const auth = getAuth(getFirebase().app);
        sendPasswordResetEmail(auth, resetEmail);
        alert('Reset email sent');
    };

    const logout = () => {
        const auth = getAuth(getFirebase().app);
        auth.signOut();
    };

    const loggedIn = (
        <i
            style={{ color: 'green', left: 5, top: 3, position: 'relative' }}
            className="bi bi-check-circle"
        ></i>
    );
    const loggedOut = (
        <i
            style={{ color: 'red', left: 5, top: 3, position: 'relative' }}
            className="bi bi-x-circle"
        ></i>
    );
    return (
        <>
            <Container className="w-100 h-100">
                <Row className="d-flex justify-content-between">
                    <Col>
                        <Header showNewDeal={false} />
                    </Col>
                </Row>
                <Row>
                    <Col style={{ textAlign: 'center', fontSize: 25 }}>
                        Login Status: {authState ? loggedIn : loggedOut}
                    </Col>
                </Row>
                <Row className="pt-5">
                    <Col xs={2}></Col>
                    <Col>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="name@example.com"
                                    onChange={e =>
                                        setLoginEmail(e.target.value)
                                    }
                                    onKeyDown={handleKeyDown}
                                />

                                <Form.Label className="pt-2">
                                    Password
                                </Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="..."
                                    onChange={e =>
                                        setLoginPassword(e.target.value)
                                    }
                                    onKeyDown={handleKeyDown}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit">
                                Login
                            </Button>
                        </Form>
                    </Col>
                    <Col xs={1}></Col>
                    <Col>
                        <Form>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="name@example.com"
                                    onChange={e =>
                                        setResetEmail(e.target.value)
                                    }
                                />
                            </Form.Group>
                            <Button variant="primary" onClick={sendReset}>
                                Reset
                            </Button>
                        </Form>
                    </Col>
                    <Col xs={2}></Col>
                </Row>
            </Container>
            <Button
                variant="primary"
                onClick={logout}
                style={{ position: 'absolute', right: 0, bottom: 0 }}
            >
                Logout
            </Button>
        </>
    );
});

export default LoginPage;
